import {IStateWithRelations} from '../../interfaces';
import {PrismaFilter} from '../../services/request/prisma.interface';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {cloneDeep} from 'lodash';
import {Injectable} from '@angular/core';
import {RequestService} from '../../services/request/request.service';
import {DataRequestServiceResponse} from '../../services/request/request-response.interface';
import {firstValueFrom} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {ErrorHandlerService} from '../../services/error-handler/error-handler.service';

export interface IStateLocationState {
  list: IStateWithRelations[];
}

const _DEFAULT_DATA: IStateLocationState = {
  list: []
}

export namespace StateActions {
  export class Get {
    static readonly type: string = '[State] Get States';
    constructor(public filters?: PrismaFilter<IStateWithRelations>) {
    }
  }
}

@State<IStateLocationState>({
  name: 'StateLocationState',
  defaults: cloneDeep(_DEFAULT_DATA),
})

@Injectable()
export class StateLocationState {
  private readonly SERVER: string = environment.SERVER

  constructor(
    private requestService: RequestService,
    private errorHandlerService: ErrorHandlerService
  ) {}

  @Selector()
  static getList(state: IStateLocationState): IStateWithRelations[] {
    return state.list;
  }

  @Action(StateActions.Get)
  async get(
    {patchState}: StateContext<IStateLocationState>,
    {filters}: StateActions.Get
  ): Promise<void> {
    const response: DataRequestServiceResponse<IStateWithRelations[]> = await firstValueFrom(this.requestService.get<IStateWithRelations[]>(`${this.SERVER}/states`, filters));
    if (response.error) throw this.errorHandlerService.createRequestException(response.serverResponse);

    patchState({
      list: response.entity ?? [],
    });
  }
}
